<script setup lang="ts">
import type { CSSProperties } from 'vue'

type Gap = 'none' | 'x3s' | 'xxs' | 'xs' | 's' | 'm' | 'mm' | 'l' | '2l' | '3l'

withDefaults(
  defineProps<{
    gap?: Gap
    align?: CSSProperties['alignItems']
  }>(),
  {
    gap: 'none',
    align: 'normal',
  }
)
</script>

<template>
  <div
    class="stack"
    :class="{
      ['gap-' + gap]: gap !== 'none',
    }"
    :style="{ alignItems: align }"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.stack {
  display: flex;
  flex-direction: column;

  &.gap-x3s {
    gap: spacingToken.$spacing-x3s;
  }

  &.gap-xxs {
    gap: spacingToken.$spacing-xxs;
  }

  &.gap-xs {
    gap: spacingToken.$spacing-xs;
  }

  &.gap-s {
    gap: spacingToken.$spacing-s;
  }

  &.gap-m {
    gap: spacingToken.$spacing-m;
  }

  &.gap-mm {
    gap: spacingToken.$spacing-mm;
  }

  &.gap-l {
    gap: spacingToken.$spacing-l;
  }

  &.gap-2l {
    gap: spacingToken.$spacing-2l;
  }

  &.gap-3l {
    gap: spacingToken.$spacing-3l;
  }
}
</style>
